module.exports = __webpack_public_path__ + "static/img/increase.a7e69d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/outer/increase.png
// module id = TOa3
// module chunks = 226